/** Compact prev/next pager with a page-of-total readout. */
export function Pagination({
  page,
  totalPages,
  total,
  onPage,
}: {
  page: number;
  totalPages: number;
  total: number;
  onPage: (page: number) => void;
}) {
  if (total === 0) return null;
  return (
    <div className="flex items-center justify-between border-t border-cream-600/15 px-5 py-3 text-sm text-cream-400">
      <span className="tnum">
        Page <span className="text-cream-200">{page}</span> of {Math.max(totalPages, 1)} ·{' '}
        <span className="text-cream-200">{total.toLocaleString()}</span> total
      </span>
      <div className="flex gap-2">
        <button
          onClick={() => onPage(page - 1)}
          disabled={page <= 1}
          className="rounded-lg border border-cream-600/20 px-3 py-1.5 text-xs font-medium text-cream-200 transition-colors hover:border-saffron-500/40 hover:text-saffron-300 disabled:cursor-not-allowed disabled:opacity-35 disabled:hover:border-cream-600/20 disabled:hover:text-cream-200"
        >
          Previous
        </button>
        <button
          onClick={() => onPage(page + 1)}
          disabled={page >= totalPages}
          className="rounded-lg border border-cream-600/20 px-3 py-1.5 text-xs font-medium text-cream-200 transition-colors hover:border-saffron-500/40 hover:text-saffron-300 disabled:cursor-not-allowed disabled:opacity-35 disabled:hover:border-cream-600/20 disabled:hover:text-cream-200"
        >
          Next
        </button>
      </div>
    </div>
  );
}
